/* eslint-disable */
export default {
  dncAlert: 'Este contacto está numa lista Não ligar.',
} as const;

// @key: @#@"dncAlert"@#@ @source: @#@"This contact is on a Do Not Call list."@#@
